<ui-kit-modal [size]="SizeScheme.Medium" [hideCloseButton]="true">
  <ng-template uiKitModalTitle>Update Available</ng-template>

  <ng-template uiKitModalContent>
    @if (secondsRemaining$ | async; as secondsRemaining) {
      <p>A new version of this application is available. The page will reload automatically in {{ secondsRemaining }} second{{ secondsRemaining === 1 ? '' : 's' }}.</p>
    }
  </ng-template>

  <ng-template uiKitModalCloseButton>
    <button uiKitButton theme="filled" color="secondary" (click)="onReload()">Reload ({{ secondsRemaining$ | async }})</button>
  </ng-template>
</ui-kit-modal>
